
import Card from './Card';
import '../css/CardSection.css'


const CardsSection = ({ cardsData, filters }) => {
  
  // Funzione per calcolare l'anno da mostrare nella prima colonna
  const getDisplayYear = () => {
    // Usa sempre l'anno selezionato nel filtro Year se disponibile, altrimenti l'anno corrente
    if (filters && filters.Year && filters.Year !== 'select..') {
      return filters.Year;
    } else {
      const currentYear = new Date().getFullYear();
      return currentYear.toString();
    }
  };

  // Funzione per calcolare l'anno di confronto nella seconda colonna
  const getCompareYear = () => {
    const displayYear = parseInt(getDisplayYear());
    
    if (filters && filters['Compare With'] === 'Previous Year') {
      return (displayYear - 1).toString();
    } else if (filters && filters['Compare With'] === 'Year -2') {
      return (displayYear - 2).toString();
    } else {
      // Fallback se il valore non è riconosciuto
      return 'Previous Year';
    }
  };

  // Calcola i valori una volta per tutte le card
  const displayYear = getDisplayYear();
  const compareYear = getCompareYear();

  // Debug per verificare i valori
  console.log('CardsSection - Display Year:', displayYear);
  console.log('CardsSection - Compare Year:', compareYear);
  console.log('CardsSection - Filters:', filters);

  return (
    <div className="cardSection">
      {cardsData.map((card, index) => (
        <Card
          key={index}
          title={card.title}
          dimCardId={card.dimCardId}
          divideBy1000={card.divideBy1000}
          isQuantity={card.isQuantity}
          infoDescription={card.infoDescription}
          tooltip={card.tooltip}
          data={card.data}
          total={card.total}
          textColor={card.textColor}
          year={displayYear}        // Anno da mostrare
          compare={compareYear}     // Anno di confronto
        />
      ))}
    </div>
  );
};

export default CardsSection;